import React from 'react'

// utils
import { remCalc, concatStyles } from 'utils'

// ui
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Form from '../Form'
import * as Indicators from '../Indicators'

export interface ActionButtonProps {
  label: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  icon?: IconDefinition
  disableIcon?: boolean
  fontSize?: number
  disabled?: boolean
  loading?: boolean
  className?: string
  type?: Form.ButtonType
  style?: React.CSSProperties
  appearance?: Form.ButtonAppearance
  align?: Form.ButtonAlignment
  form?: string
}

const DEFAULT_MARGINS = 'my-1'

export const ActionButton: React.FC<ActionButtonProps> = ({
  disableIcon = true,
  disabled,
  fontSize,
  icon,
  label,
  loading,
  style,
  onClick: handleClick,
  className,
  type,
  appearance = 'actionable',
  align = 'stretch',
  form,
}) => {
  const fontSizeStyle = { fontSize: fontSize ? remCalc(fontSize) : 'inherit' }
  const labelStyles = {
    marginRight: disableIcon === true ? 'auto' : 16,
    ...fontSizeStyle,
  }

  return (
    <Form.Button
      appearance={appearance}
      align={align}
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      style={style}
      className={concatStyles([className, DEFAULT_MARGINS])}
      form={form}
    >
      <div className="flex w-full">
        <span className="ml-auto whitespace-no-wrap" style={labelStyles}>
          {label}
        </span>
        {disableIcon === true || loading ? null : (
          <span className="mr-auto" style={fontSizeStyle}>
            <FontAwesomeIcon icon={icon || faChevronRight} />
          </span>
        )}
        {loading ? (
          <div className="flex mr-auto">
            <Indicators.Spinner />
          </div>
        ) : null}
      </div>
    </Form.Button>
  )
}

ActionButton.displayName = 'Content.ActionButton'
